import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=003b7ae4&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Footer.vue?vue&type=style&index=0&id=003b7ae4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "003b7ae4",
  null
  ,true
)

export default component.exports